import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  loading: false,
  error: null,
  userProfile: null,
  logoutloading: false,
  logout:false,
};

const authSlice = createSlice({ 
  name: "auth",
  initialState,
  reducers: {
    loginRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.loading = false;
      state.user = action.payload.user;
    },
    loginFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearError: (state) => {
      state.error = null;
    },
    logoutRequest: (state) => {
      state.loading = false;
      state.logoutloading = true;
    },
    logoutSuccess: (state) => {
      state.user = null;
      state.logout=true;
      state.logoutloading = false;

    },
    logoutFailure: (state, action) => {
      state.logoutloading = false;
    },
    registerRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    registerSuccess: (state, action) => {
      state.loading = false;
      state.user = action.payload;
      state.userProfile = action.payload.user;
    },
    registerFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    profileUpdateRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    profileUpdateSuccess: (state, action) => {
      state.loading = false;
      state.user = action.payload;
    },
    profileUpdateFailure: (state, action) => {
    },
    getProfileDetails: (state, action) => {
      state.loading = true;
    },
    getProfileDetailsSuccess: (state, action) => {
      state.loading = false;
      state.user = action.payload;
    },
    getProfileDetailsError: (state, action) => {
      state.loading = false;
    },
  },
});

export const {
  loginRequest,
  loginSuccess,
  loginFailure,
  clearError,
  logoutRequest,
  logoutSuccess,
  logoutFailure,
  registerFailure,
  registerRequest,
  registerSuccess,
  profileUpdateFailure,
  profileUpdateRequest,
  profileUpdateSuccess,
  getProfileDetails,
  getProfileDetailsSuccess,
  getProfileDetailsError,
} = authSlice.actions;
export default authSlice.reducer;
